// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2J6qM","cell":"ColumnAccessor_cell__1FJQ8","firstCellAccent":"ColumnAccessor_firstCellAccent__1xhul"};